exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.apex-Content[data-v-2d01b25f] {\n  padding-left: 14px;\n  padding-right: 14px;\n  overflow: hidden;\n}\n.apex-Description-Messages[data-v-2d01b25f] {\n  padding-top: 14px;\n}\n.apex-image[data-v-2d01b25f] {\n  margin-top: 30px;\n}\n", ""]);

